import { render } from "./Basico.vue?vue&type=template&id=ab40cfae&scoped=true"
import script from "./Basico.vue?vue&type=script&lang=js"
export * from "./Basico.vue?vue&type=script&lang=js"

import "./Basico.vue?vue&type=style&index=0&id=ab40cfae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ab40cfae"

export default script